import { createApi } from '@reduxjs/toolkit/query/react';
import { z } from 'zod';
import { baseQuery } from './baseQuery';
import { validateResponse } from './validateResponse';

export const AdminV3StubSchema = z.object({ message: z.string() });
export type AdminV3Stub = z.infer<typeof AdminV3StubSchema>;

export const adminV3Api = createApi({
    reducerPath: 'adminV3Api',
    baseQuery,
    endpoints: (builder) => ({
        getAdminV3: builder.query<AdminV3Stub, void>({
            query: () => 'api/v3/admin',
            transformResponse: validateResponse(AdminV3StubSchema),
        }),
    }),
});

export const { useGetAdminV3Query } = adminV3Api;
